import { createContext, type Context } from 'react';

import type { InvitedAppShortcutAllowedApsKey } from '../../common/types';

interface InvitedAppShortcutsContextProps {
	impressedProducts: Record<InvitedAppShortcutAllowedApsKey, boolean>;
}

export const InvitedAppShortcutsContext: Context<InvitedAppShortcutsContextProps> = createContext<InvitedAppShortcutsContextProps>({
	impressedProducts: {
		JIRA_SOFTWARE: false,
		CONFLUENCE: false,
	},
});
